import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { HomePage } from './pages/HomePage';
import { OrderPage } from './pages/OrderPage';
import { ConfirmationPage } from './pages/ConfirmationPage';
import { TrackingPage } from './pages/TrackingPage';
import { OrderProvider } from './context/OrderContext';
export function App() {
  return <Router data-id="element-0">
      <OrderProvider data-id="element-1">
        <Layout data-id="element-2">
          <Routes data-id="element-3">
            <Route path="/" element={<HomePage data-id="element-5" />} data-id="element-4" />
            <Route path="/order" element={<OrderPage data-id="element-7" />} data-id="element-6" />
            <Route path="/confirmation" element={<ConfirmationPage data-id="element-9" />} data-id="element-8" />
            <Route path="/tracking" element={<TrackingPage data-id="element-11" />} data-id="element-10" />
          </Routes>
        </Layout>
      </OrderProvider>
    </Router>;
}